module.exports = __webpack_public_path__ + "img/hr-green-pita-01.7299f754.png";